<template>
  <div class="flex gap-x-4">
    <img
      v-if="author.profile_image"
      class="size-24 rounded-2xl shadow-xl"
      :src="author.profile_image"
      :alt="author.name"
      loading="lazy"
    >
    <div class="flex flex-col">
      <p class="font-semibold text-lg">
        {{ author.name }}
      </p>

      <p class="text-sm text-gray-500">
        {{ author.bio }}
      </p>

      <NuxtLink
        :to="
          localePath({
            name: 'author-slug',
            params: {
              slug: author.slug,
            },
          })
        "
        class="mt-2 link text-sm"
      >
        {{ t('viewMorePosts') }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Author } from '@tryghost/content-api'

defineProps<{
  author: Author
}>()

const { t } = useI18n()

const localePath = useLocalePath()
</script>

<i18n lang="json">
{
  "en": {
    "viewMorePosts": "View more posts"
  },
  "fr": {
    "viewMorePosts": "Voir plus articles"
  }
}
</i18n>
